import { nanoid } from "@reduxjs/toolkit";
import { memo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../../store/rootReducer";
import { CommonFormElProps } from "../../types";
import { MultiPreview } from "../ImagePreview";
import { removeImage, selectMultiImages, setImage } from "../images.slice";
import { Images, ImageSectionId } from "../types";
import { ImageProperties } from "../utilities/FilesProperties";
import { imageTypes, localStorageNames } from "../utilities/enums";
import {
  ListOfFiles,
  removeLocalStorageVariable,
} from "../utilities/localStorageManagement";

import { ImageUploader } from "./ImageUploader";

export type MultiImageUploaderProps = {
  readonly maxImageNumber: number;
  readonly imageSectionId: ImageSectionId;
  readonly ignoredKeys?: Array<string>;
} & Pick<CommonFormElProps, "id" | "isComplex">;

export const MultiImageUploader = memo<MultiImageUploaderProps>(
  ({ imageSectionId, maxImageNumber, ignoredKeys = [] }) => {
    const images = useSelector(
      (state: RootState): Images =>
        selectMultiImages(state, {
          section: imageSectionId,
          ignoredKeys,
        })
    );

    let names = "";
    for (let index = 0; index < Object.keys(images).length; index++) {
      names += Object.keys(images)[index] + "\n";
      if (ListOfFiles.multiFiles.length > index)
        ListOfFiles.multiFiles[index].fileId = Object.keys(images)[index];
    }
    const multiImageNumber = Object.keys(images).length;
    const dispatch = useDispatch();
    const fileslist = ListOfFiles.GetListOfFiles();
    ImageProperties.imageType = imageTypes.multi;
    ImageProperties.listIndex = 0;
    const setFiles = (uploadedFiles: Array<File>) => {
      /* LPPLWEBMOB-454 */
      let index = 0;
      uploadedFiles.forEach((uploadedFile: File) => {
        const ifpdf = uploadedFile.name.includes(".pdf") ? "true" : "false";
        fileslist.Add(
          "multi",
          {
            fileId: Object.keys(images)[index],
            fileIndex: index,
            ifFileIsPdf: ifpdf == "true",
          },
          index
        );
        ImageProperties.imageType = imageTypes.multi;
        index = index + 1;
        dispatch(
          setImage({
            section: imageSectionId,
            type: nanoid(),
            src: uploadedFile,
          })
        );
      });
    };
    const handleOnImageQuotaExceeded = () => {
      alert("image quota exceeded");
    };
    const handleOnFileRemove = (imageId: string) => {
      const [type, index] = fileslist.Search(imageId);
      fileslist.Remove("multi", ListOfFiles.multiFiles[index - 1], index);
      return dispatch(removeImage({ section: imageSectionId, type: imageId }));
    };

    const imageNumber = Object.keys(images).length;

    return (
      <>
        {imageNumber > 0 && (
          <MultiPreview images={images} onFileRemove={handleOnFileRemove} />
        )}
        <ImageUploader
          currentImageNumber={imageNumber}
          maxImageNumber={maxImageNumber}
          onImageQuotaExceeded={handleOnImageQuotaExceeded}
          setFiles={setFiles}
        />
      </>
    );
  }
);
